import {
    clientsGrid,
    dropDown,
    postClientTypes,
    targetClientTypes,
    updateClientTypes,
    targetClientByPhoneTypes,
    fileDocumentTypes,
} from './interfaces';
import axios from 'axios';

const apiURL = process.env.REACT_APP_API_URL;

export const getClients = async (showDeleted: boolean): Promise<clientsGrid[]> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get<clientsGrid[]>(`https://${apiURL}/Client?ShowDeleted=${showDeleted}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const clientData: clientsGrid[] = response.data.map((item) => ({
        clientId: item.clientId,
        clientName: item.clientName,
        accountRef: item.accountRef,
        contactName: item.contactName,
        phone: item.phone,
        email: item.email,
        clientAddr: item.clientAddr,
        deletedDate: item.deletedDate,
        what3Words: item.what3Words,
    }));

    return clientData;
};


export const getClientsDropdown = async (searchTerm: string): Promise<dropDown[]> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/Client/ForDropdown?filter=${encodeURIComponent(searchTerm)}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const data = response.data;

    const clientDropdownData: dropDown[] = (data as dropDown[]).map((item: any) => ({
        text: item.text,
        value: item.value,
    }));

    return clientDropdownData;
};

export const getClientsForJobsFilterDropdown = async (searchTerm: string): Promise<dropDown[]> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/Jobs/Clients/ForFilterDropdown?filter=${encodeURIComponent(searchTerm)}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const data = response.data;

    const clientDropdownData: dropDown[] = (data as dropDown[]).map((item: any) => ({
        text: item.text,
        value: item.value,
    }));

    return clientDropdownData;
};


export const submitClient = async (client: postClientTypes) => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios({
        url: `https://${apiURL}/Client`,
        method: 'post',
        data: {
            clientName: client.clientName,
            accountRef: client.accountRef,
            contactName: client.contactName,
            phone: client.phone,
            email: client.email,
            clientAddr: client.clientAddr,
            postcode: client.postcode,
            phone2: client.phone2,
            fax: client.fax,
            tradeContact: client.tradeContact,
            email2: client.email2,
            email3: client.email3,
            websiteUrl: client.websiteUrl,
            vatNum: client.vatNum,
            directdebitEmail: client.directdebitEmail,
        },
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const data: updateClientTypes = response.data;

    const clientId = data.clientId; 
    
    if (clientId) {
      //addClientToSage(clientId);
    } else {
      throw new Error('ClientId not found in response');
    }

    return data;
};

//#region addClientToSage
/*
export const addClientToSage = async (clientId: number) => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({    
    url: `https://${apiURL}/Client/SendToSage/${clientId}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data = response.data

  return data;
}
  */
//#endregion

export const getTargetClient = async (clientId: number): Promise<targetClientTypes> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/Client/${clientId}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const data: targetClientTypes = response.data;

    const targetClientData: targetClientTypes = {
        clientId: data.clientId,
        clientName: data.clientName,
        accountRef: data.accountRef,
        contactFirstName: data.contactFirstName,
        contactLastName: data.contactLastName,
        phone: data.phone,
        email: data.email,
        clientAddr: data.clientAddr,
        postcode: data.postcode,
        phone2: data.phone2,
        fax: data.fax,
        tradeContact: data.tradeContact,
        email2: data.email2,
        email3: data.email3,
        websiteUrl: data.websiteUrl,
        vatNum: data.vatNum,
        directdebitEmail: data.directdebitEmail,
        deletedDate: data.deletedDate,
        badDebter: data.badDebter || false,
        defaultAdjustment: data.defaultAdjustment ?? 0,
        primaryContact: data.primaryContact ?? null,
        contacts: data.contacts ?? [],
    };

    return targetClientData;
};

export const updateClient = async (client: updateClientTypes, clientId: number) => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios({
        url: `https://${apiURL}/Client/${clientId}`,
        method: 'put',
        data: {
            clientId: clientId,
            clientName: client.clientName,
            accountRef: client.accountRef,
            contactName: client.contactName,
            phone: client.phone,
            email: client.email,
            clientAddr: client.clientAddr,
            postcode: client.postcode,
            phone2: client.phone2,
            fax: client.fax,
            tradeContact: client.tradeContact,
            email2: client.email2,
            email3: client.email3,
            websiteUrl: client.websiteUrl,
            vatNum: client.vatNum,
            directdebitEmail: client.directdebitEmail,
            defaultAdjustment: client.defaultAdjustment ?? 0,
        },
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const data: updateClientTypes = response.data;

    // updateClientToSage(clientId);

    return data;
};

//#region updateInvoiceToSage
/*
export const updateClientToSage = async (clientId: number) => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    
    url: `https://${apiURL}/Client/SendToSage/${clientId}`,
    method: 'post',
    
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data = response.data

  return data;
}
  */
//#endregion

export const deleteClient = async (clientId: number) => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.delete(`https://${apiURL}/Client/${clientId}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const data: any = response.data;

    return data;
};

export const undeleteClient = async (clientId: number) => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.put(`https://${apiURL}/Client/${clientId}/Undelete`, null, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const data: any = response.data;

    return data;
};

export const exportClients = async () => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/Client/ExportClients`, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));

    const contentDisposition = response.headers['content-disposition'];
    let filename = 'clients.csv';

    if (contentDisposition) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        let matches = filenameRegex.exec(contentDisposition);
        if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
        }
    }

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
};

export const getTargetClientByPhone = async (phone: string): Promise<targetClientByPhoneTypes> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/Client/ByPhone/${phone}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const data: targetClientByPhoneTypes = response.data;
    console.log("data here", data);

    const targetClientData: targetClientByPhoneTypes = {
        contactId: data.contactId,
        partialMatch: data.partialMatch,
        possibleClients: {
            disabled: data.possibleClients.disabled,
            group: {
                disabled: data.possibleClients.group?.disabled ? data.possibleClients.group.disabled : false,
                name: data.possibleClients.group?.name ? data.possibleClients.group.name : '',
            },
            selected: data.possibleClients.selected,
            text: data.possibleClients.text,
            value: data.possibleClients.value,
        },
        possibleSites: {
            disabled: data.possibleSites.disabled,
            group: {
                disabled: data.possibleSites.group?.disabled ? data.possibleSites.group.disabled : false,
                name: data.possibleSites.group?.name ? data.possibleSites.group.name : '',
            },
            selected: data.possibleSites.selected,
            text: data.possibleSites.text,
            value: data.possibleSites.value,
        },
        matchingClient: {
            openJobs: data.matchingClient?.openJobs ? data.matchingClient.openJobs : 0,
            openEnquiries: data.matchingClient?.openEnquiries ? data.matchingClient.openEnquiries : 0,
            openQuotes: data.matchingClient?.openQuotes ? data.matchingClient.openQuotes : 0,
            clientId: data.matchingClient?.clientId ? data.matchingClient.clientId : 0,
            clientName: data.matchingClient?.clientName ? data.matchingClient.clientName : '',
            accountRef: data.matchingClient?.accountRef ? data.matchingClient.accountRef : '',
            contactFirstName: data.matchingClient?.contactFirstName ? data.matchingClient.contactFirstName : '',
            contactLastName: data.matchingClient?.contactLastName ? data.matchingClient.contactLastName : '',
            phone: data.matchingClient?.phone ? data.matchingClient.phone : '',
            email: data.matchingClient?.email ? data.matchingClient.email : '',
            clientAddr: data.matchingClient?.clientAddr ? data.matchingClient.clientAddr : '',
            postcode: data.matchingClient?.postcode ? data.matchingClient.postcode : '',
            phone2: data.matchingClient?.phone2 ? data.matchingClient.phone2 : '',
            fax: data.matchingClient?.fax ? data.matchingClient.fax : '',
            tradeContact: data.matchingClient?.tradeContact ? data.matchingClient.tradeContact : '',
            email2: data.matchingClient?.email2 ? data.matchingClient.email2 : '',
            email3: data.matchingClient?.email3 ? data.matchingClient.email3 : '',
            websiteUrl: data.matchingClient?.websiteUrl ? data.matchingClient.websiteUrl : '',
            vatNum: data.matchingClient?.vatNum ? data.matchingClient.vatNum : '',
            directdebitEmail: data.matchingClient?.directdebitEmail ? data.matchingClient.directdebitEmail : '',
        },
        matchingSite: {
            siteId: data.matchingSite?.siteId,
            siteAddr: data.matchingSite?.siteAddr,
            postcode: data.matchingSite?.postcode,
        },
    };

    return targetClientData;
};

export const getAccountRef = async (client: string): Promise<string> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/Client/GetAccountReference/${client}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const data = response.data;

    return data;
};


export const getClientDocuments = async (clientId: number): Promise<fileDocumentTypes[]> => {
    const token = localStorage.getItem('authToken')
  
    if (!token) {
      throw new Error('Authorization token not found')
    }
  
    const response = await axios.get(
      `https://${apiURL}/Client/${clientId}/Documents`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
      }
    )
  
    const data: fileDocumentTypes[] = response.data
  
    return data
  }